import * as localStorageKeys from '../../../constants/localStorageKeys';

/**
 * Checks whether the left navigation menu must be hidden on demand (token login `hideMenu` flag).
 * @return {Boolean} true if the menu should be hidden
 * */
export const isMenuHidden = () => localStorage.getItem(localStorageKeys.HIDE_MENU) === 'true';
